import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaFilePdf } from "react-icons/fa";
import { GiTakeMyMoney, GiReceiveMoney } from "react-icons/gi";
import {
	FaRegMoneyBillAlt,
	FaMobileAlt,
	FaSms,
	FaCalculator,
} from "react-icons/fa";
import formatDate from "./formatDate";
import { PartnersData } from "./data";

export const HomeAbout = () => (
	<section className='sec'>
		<div className='container about-grid'>
			<div className='about-text'>
				<h2 className='sec-title'>About Champawati</h2>
				<p>
					<strong>Champawati</strong> is a well known Saving and Credit
					Co-operative, working in the field since 2067/68 BS. Registration
					number is 3387/067/068. It has won the trust of thousands of happy
					members.
				</p>
				<p>
					We focus on giving the best services to our members and provide
					flexible loans. We have <strong>SMS Banking</strong>,{" "}
					<strong>Mobile Banking</strong> and <strong>QR Code</strong> payment.
					Members stay up to date without visiting the office. We share every
					event and notice through this website.
				</p>
				<Link to='/profile' className='btn-link'>
					Read our profile
				</Link>
			</div>
			<div className='facts'>
				<dl>
					<dt>Working since</dt>
					<dd>2067/68 BS</dd>
					<dt>Registration number</dt>
					<dd>3387/067/068</dd>
					<dt>Office</dt>
					<dd>Machhapokhari, Kathmandu-16</dd>
					<dt>Phone</dt>
					<dd>01-5906224, 9851279532</dd>
				</dl>
			</div>
		</div>
	</section>
);

const SERVICES = [
	{
		title: "Deposit",
		url: "/deposit",
		icon: <GiReceiveMoney />,
		text: "Saving accounts for members, with the forms you need.",
	},
	{
		title: "Loan",
		url: "/loan",
		icon: <GiTakeMyMoney />,
		text: "Loans for members. See how to apply and download the loan form.",
	},
	{
		title: "Remittance",
		url: "/remittance",
		icon: <FaRegMoneyBillAlt />,
		text: "Receive money sent from abroad through our remittance partners.",
	},
	{
		title: "Mobile Banking",
		url: "/mobilebanking",
		icon: <FaMobileAlt />,
		text: "Use your account from your phone, and pay with QR code.",
	},
	{
		title: "SMS Banking",
		url: "/smsbanking",
		icon: <FaSms />,
		text: "Banking services by text message.",
	},
	{
		title: "EMI Calculator",
		url: "/#emi",
		icon: <FaCalculator />,
		text: "Estimate your monthly loan payment before you apply.",
	},
];

export const HomeServices = () => (
	<section className='sec alt'>
		<div className='container'>
			<h2 className='sec-title'>Our Services</h2>
			<p className='sec-sub'>सवल, व्यवसायिक र गुणस्तरिय सेवाकोलागि चम्पावति साकोस ।</p>
			<div className='cards'>
				{SERVICES.map((service) => (
					<Link to={service.url} className='card' key={service.title}>
						<div className='card-icon'>{service.icon}</div>
						<h3>{service.title}</h3>
						<p>{service.text}</p>
						<span className='more'>Learn more →</span>
					</Link>
				))}
			</div>
		</div>
	</section>
);

export const NewsAndDownloads = () => {
	const [news, setNews] = useState([]);
	const [downloads, setDownloads] = useState([]);

	useEffect(() => {
		fetch("/api/events/")
			.then((res) => res.json())
			.then((data) => {
				if (Array.isArray(data)) {
					setNews(
						[...data].sort((a, b) => new Date(b.date) - new Date(a.date))
					);
				}
			})
			.catch((error) => console.log(error));
		fetch("/api/downloadfile/")
			.then((res) => res.json())
			.then((data) => {
				if (Array.isArray(data)) setDownloads(data);
			})
			.catch((error) => console.log(error));
	}, []);

	return (
		<section className='sec'>
			<div className='container two-col'>
				<div className='panel'>
					<div className='panel-head'>Latest News</div>
					<div className='panel-body'>
						{news.length === 0 && <p className='empty'>No news yet.</p>}
						{news.slice(0, 5).map((item) => (
							<div className='list-item' key={item.id}>
								{item.outside_url ? (
									<a
										href={item.outside_url}
										target='_blank'
										rel='noopener noreferrer'
									>
										{item.title}
									</a>
								) : (
									<Link to={`/singleevent/${item.id}`}>{item.title}</Link>
								)}
								<small>{formatDate(item.date)}</small>
							</div>
						))}
					</div>
					<div className='panel-foot'>
						<Link to='/events'>All news</Link>
					</div>
				</div>
				<div className='panel'>
					<div className='panel-head'>Forms and Downloads</div>
					<div className='panel-body'>
						{downloads.length === 0 && <p className='empty'>No files yet.</p>}
						{downloads.map((file) => (
							<div className='list-item' key={file.id}>
								<a href={file.file} download className='dl-link'>
									<FaFilePdf />
									{file.title}
								</a>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
};

export const RemittancePartners = () => (
	<section className='sec alt'>
		<div className='container'>
			<h2 className='sec-title'>Remittance Partners</h2>
			<p className='sec-sub'>Receive money sent from abroad through these partners.</p>
			<div className='partners-row'>
				{PartnersData.map((item) => (
					<div className='partner-card' key={item.id}>
						<img src={item.img} alt='Remittance partner' />
					</div>
				))}
			</div>
		</div>
	</section>
);
